import _ from 'lodash';
import moment from 'moment';

const DefaultDateFormat = 'hh:mm DD/MM/YYYY';

export default function(vueInstance) {
	vueInstance.filter('date', (value, format = DefaultDateFormat) => {
		if (value) {
			return moment(new Date(String(value))).format(format);
		}
	});

	vueInstance.filter('number', (value) => {
		if (!value) return value;

		const chunkSize = 3;
		const str = parseInt(value).toString();
		if (str.length <= chunkSize) return str;

		let fmt = '';
		for (let c = 0, i = str.length - 1; i >= 0; c++, i--) {
			if (c && c % chunkSize === 0) fmt = ',' + fmt;

			fmt = str[i] + fmt;
		}

		return fmt;
	});

	vueInstance.filter('elapsed', (value) => {
		value /= 1000;
		const hours = parseInt(Math.floor(value / 360));
		const minutes = parseInt(Math.floor((value - (hours * 360)) / 60));
		const seconds = parseInt((value - ((hours * 360) + (minutes * 60))) % 60);

		const dHours = hours > 9 ? hours : ('0' + hours);
		const dMins = minutes > 9 ? minutes : ('0' + minutes);
		const dSecs = seconds > 9 ? seconds : ('0' + seconds);

		return dHours + ':' + dMins + ':' + dSecs;
	});

	vueInstance.filter('elapsed2', (value) => {
		value /= 1000;
		const hours = parseInt(Math.floor(value / 3600));
		const minutes = parseInt(Math.floor((value - (hours * 3600)) / 60));
		const seconds = parseInt((value - ((hours * 3600) + (minutes * 60))) % 60);

		const dHours = hours > 9 ? hours : ('0' + hours);
		const dMins = minutes > 9 ? minutes : ('0' + minutes);
		const dSecs = seconds > 9 ? seconds : ('0' + seconds);

		return dHours + ':' + dMins + ':' + dSecs;
	});

	vueInstance.filter('ago', (value) => {
		if (value) {
			return moment(new Date(String(value))).fromNow();
		}
	});

	vueInstance.filter('bytes', (num, breakSegments, decimalPlaces = 3, mini = false) => {
		// jacked from: https://github.com/sindresorhus/pretty-bytes
		if (typeof num !== 'number' || isNaN(num)) {
			throw new TypeError('Expected a number');
		}

		const neg = num < 0;
		const units = [(mini ? 'B' : 'Bytes'), 'kB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];

		if (neg) num = -num;
		if (num < 1) {
			const value = (neg ? '-' : '') + num;
			return breakSegments ? { value, unit: units[0] } : (value + ' Bytes');
		}

		const exponent = Math.min(Math.floor(Math.log(num) / Math.log(1000)), units.length - 1);
		const unit = units[exponent].toLowerCase();

		num = (num / Math.pow(1000, exponent)).toFixed(decimalPlaces) * 1;

		const value = (neg ? '-' : '') + num;
		return breakSegments ? { value: Number(value), unit } : (value + ' ' + unit);
	});

	vueInstance.filter('capitalize', (text) => {
		// copied from https://github.com/sindresorhus/pretty-bytes
		return _.capitalize(text);
	});

	vueInstance.filter('paddStart', (text, maxLen, char = '0') => {
		return _.padStart(text, maxLen, char);
	});

	vueInstance.filter('paddEnd', (text, maxLen, char = '0') => {
		return _.padEnd(text, maxLen, char);
	});

	vueInstance.filter('max', (value, cmpValue) => {
		return Math.max(value, cmpValue);
	});

	vueInstance.filter('shortstring', (value, maxLen) => {
		value = value || '';
		return value.length <= maxLen ? value : value.substr(0, maxLen) + ' ..';
	});

	vueInstance.filter('normalizedFPS', (value) => {
		return Number.isFinite(value) ? Math.ceil(value) : value;
	});
}
